import { select } from '@js/util/select.js'

import Swiper from 'swiper'
import { A11y, Navigation } from 'swiper/modules'

select('.wpce-testimonials', testimonialElement => {
  const swiperElement = testimonialElement.querySelector('.swiper')

  for (const box of swiperElement.querySelectorAll('.testimonial-box')) {
    box.classList.add('swiper-slide')
  }

  let swiper = new Swiper(swiperElement, {
    modules: [A11y, Navigation],
    direction: 'horizontal',
    loop: true,
    centeredSlides: true,
    slidesPerView: 1,
    autoHeight: true,
    allowTouchMove: false,

    navigation: {
      prevEl: testimonialElement.querySelector('.swiper-button-prev'),
      nextEl: testimonialElement.querySelector('.swiper-button-next'),
    },
  })

  return () => {
    swiper.destroy()
  }
})
